import { FC, useContext } from 'react';
import DocumentTemplatePreview from '../../Molecules/Document/DocumentTemplatePreview';
import { ContractContext } from '../../Service/Context/ContractContextV2';

const ContractPreview: FC = () => {
  const { contract, savePatch } = useContext(ContractContext);
  if (!contract) {
    return null;
  }
  const { id, draft } = contract;

  return (
    <DocumentTemplatePreview
      portalSupported
      url={`${process.env.REACT_APP_DOCUMENT_SERVICE_URL}/contracts/${id}/pdf`}
      entityType="contracts"
      entity={contract}
      draft={draft}
      patchEntity={savePatch}
    />
  );
};

export default ContractPreview;
